import Component from './component.vue';

export * from './const';
export default Component;



// WEBPACK FOOTER //
// ./src/components/parts/catalog/card/components/defer/index.ts